// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1D_w9","info":"Note_info__31UgB","note":"Note_note__1OjXk","actions":"Note_actions__2JK5W"};